export default __webpack_public_path__ + "static/media/chasing-ring.f9e0cdd4.less";